import React, { useEffect, useState, useContext } from 'react'
import QRCode from 'react-qr-code'
import AuthContext from '../../../Product/context/auth/authContext'
import Copy from '../../../utils/CommonFunctionality/Share/Copy'

const QRCodeGenerator = (props) => {
    const authContext = useContext(AuthContext)
    const { user } = authContext

    const [value, setValue] = useState('')
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'

    useEffect(() => {
        if (user) {
            console.log('QR Code value:', user.id, user.tw_json)
            if (isVarifiedGfTheme) {
                if (user.tw_json) {
                    setValue(user.tw_json)
                } else {
                    setValue('undefind')
                }
            } else {
                setValue(user.id)
            }
        }
    }, [user])

    return value ? (
        <>
            {isVarifiedGfTheme ? (
                <div className="text-center">
                    {user?.tw_json ? (
                        <>
                            {user?.tw_json} <Copy text={user?.tw_json} textOnly={true} />
                        </>
                    ) : (
                        'Referral code not generated'
                    )}
                </div>
            ) : (
                <div
                    className="p-3 mb-3 text-center"
                    style={{ width: 'fit-content', margin: 'auto', border: '1px solid #cbcbcb' }}
                >
                    {props.name && <h5 className="font-bold mb-3">{props.name}</h5>}
                    <QRCode
                        value={String(value)}
                        size={140}
                        bgColor="#ffffff"
                        fgColor="#000000"
                        level="H"
                    />
                </div>
            )}
        </>
    ) : null
}

export default QRCodeGenerator
